!(function() {
  for (
    var e,
      t,
      n = window.location.host,
      i = {
        callbacks: {},
        send: function(e, t) {
          this.dispatchMessage('event', e, t);
        },
        sendCallback: function(e, t) {
          var n = s.createEnvelope(e, 'return', { returnStr: t });
          this.dispatchMessage('callback', n, function() {});
        },
        triggerCallback: function(e, t) {
          var n = this;
          setTimeout(function() {
            n.callbacks[e](t);
          }, 0);
        },
        dispatchMessage: function(e, t, n) {
          var i, s
          ;(this.callbacks[t.id] = function(e) {
            n(e);
          }),
            (i =
              'jockey://' +
              e +
              '/' +
              t.id +
              '?' +
              encodeURIComponent(JSON.stringify(t))),
            (s = document.createElement('iframe')),
            s.setAttribute('src', i),
            document.documentElement.appendChild(s),
            s.parentNode.removeChild(s),
            (s = null);
        }
      },
      s = {
        listeners: {},
        dispatcher: null,
        messageCount: 0,
        on: function(e, t) {
(!this.listeners.hasOwnProperty(e) ||
            !(this.listeners[e] instanceof Array)) &&
            (this.listeners[e] = []),
            this.listeners[e].push(t);
        },
        off: function(e) {
(!this.listeners.hasOwnProperty(e) ||
            !(this.listeners[e] instanceof Array)) &&
            (this.listeners[e] = []),
            (this.listeners[e] = []);
        },
        send: function(e, t, n) {
          t instanceof Function && ((n = t), (t = null)),
            (t = t || {}),
            (n = n || function() {});
          var i = this.createEnvelope(this.messageCount, e, t);
          this.dispatcher.send(i, n), (this.messageCount += 1);
        },
        trigger: function(e, t, n) {
          var i;
          var s;
          var r = this;
          var a = this.listeners[e] || [];
          var o = 0;
          var c = function(e) {
(o += 1), o >= a.length && r.dispatcher.sendCallback(t, e);
          };
          for (i = 0; i < a.length; i++)
            { (s = a[i]), s.length <= 1 ? (s(n), c()) : s(n, c); }
        },
        triggerCallback: function(e, t) {
          this.dispatcher.triggerCallback(e, t);
        },
        createEnvelope: function(e, t, i, s) {
          return { id: e, type: t, host: n, payload: i, returnStr: s }
        },
        createCallbackEnvelope: function(e, t) {
          return { id: e, returnStr: t }
        }
      },
      r = {
        send: function(e, t) {
          t();
        },
        triggerCallback: function() {},
        sendCallback: function() {}
      },
      a = 0,
      c = ['iPad', 'iPhone', 'iPod'];
    a < c.length;
    a++
  )
    { if (navigator.platform.indexOf(c[a]) >= 0) {
      break
    } }
(e = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
    navigator.userAgent
  )),
    (t = navigator.userAgent.toLowerCase().indexOf('android') > -1),
    (s.dispatcher = e || t ? i : r),
    (window.Jockey = s);
})();

var inDuAppBrowser = /duapp|poizon/.test(navigator.userAgent.toLowerCase());
var warningMsg = '有内鬼终止交易！';
function notInDuAppHandler(event, useless) {
    console.log(warningMsg, "eventName:" + event);
}
var SafeJockey = /** @class */ (function () {
    function SafeJockey() {
    }
    SafeJockey.handleCallback = function (payload, reject, resolve) {
        var status = payload.status, data = payload.data, msg = payload.msg;
        if (status !== 200) {
            reject(new Error(msg));
        }
        else {
            resolve(data);
        }
    };
    SafeJockey.promiseWithTimeout = function (target, timeOutPeriod) {
        timeOutPeriod = timeOutPeriod || 500;
        return Promise.race([
            target,
            new Promise(function (resolve, reject) {
                setTimeout(function () {
                    reject(new Error("timeout:" + timeOutPeriod));
                }, timeOutPeriod);
            })
        ]);
    };
    SafeJockey.safe = function (unsafeJockey) {
        return SafeJockey.inDuAppBrowser ? unsafeJockey : notInDuAppHandler;
    };
    SafeJockey.prototype.off = function (event) {
        SafeJockey.safe(Jockey.off).call(Jockey, event);
    };
    SafeJockey.prototype.on = function (event, callback) {
        SafeJockey.safe(Jockey.on).call(Jockey, event, callback);
    };
    SafeJockey.prototype.sendSync = function (event, params) {
        console.log('sendSync', event);
        SafeJockey.safe(Jockey.send).call(Jockey, event, params);
    };
    SafeJockey.prototype.onOnce = function (event, callback) {
        var _this = this;
        this.on(event, function (payload) {
            // 移除监听事件
            _this.off(event);
            callback(payload);
        });
    };
    SafeJockey.prototype.send = function (event, params, timeOutPeriod) {
        var _this = this;
        return SafeJockey.promiseWithTimeout(new Promise(function (resolve, reject) {
            if (inDuAppBrowser) {
                _this.onOnce(event + "Callback", function (payload) {
                    SafeJockey.handleCallback(payload, reject, resolve);
                });
                console.log('send', event);
                _this.sendSync(event, params);
            }
            else {
                reject(new Error(warningMsg));
            }
        }), timeOutPeriod).catch(function (e) {
            // 移除监听事件
            console.log("send err" + e.message, event);
            _this.off(event + "Callback");
            throw new Error(e.message + ",eventName:" + event);
        });
    };
    SafeJockey.inDuAppBrowser = inDuAppBrowser;
    return SafeJockey;
}());

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

// 调起native登录页面
var CALL_NATIVE_LOGIN_MODAL = 'CallNativeLoginModal';

/***
 * informer 埋点事件
 */
var EVENT_TRACKING = 'EventTracking';

/***
 * 以下是superman的功能列表
 */
//  设置页面标题
var SET_TITLE = 'setTitle';
// 设置页面分享按钮
var SHOW_SHARE_BTN = 'ShowShareBtn';
// 链接客服
var CONNECT_STAFF = 'connectStaff';
//  大图预览
var PREVIEW_IMAGES = 'showContentImages';
//  设置分享的具体内容
var SET_SHARE_CONTENT = 'setShareContent';
//  调起原生分享功能
var EVOKE_SHARE = 'evokeShare';
//  获取native信息
var GET_PLATFORM_INFO = 'getPlatformInfo';

var TouristSafeJockey = /** @class */ (function (_super) {
    __extends(TouristSafeJockey, _super);
    function TouristSafeJockey() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // 游客模式的状态码
        _this.TOURIST_CODE = 7999;
        // token失效的状态码
        _this.TOKEN_EXPIRE_CODE = 700;
        // 需要登录的jockey事件
        _this.JOCKEY_NEED_LOGIN = [
            'getCoupon',
            'applySettle',
            'getShareInfo',
            'shareGetCoupon',
            'getShareCoupon',
            'goRedPacketPage',
            'connectStaff',
            'applyDr',
            'requestPush',
            'zan',
            'replyUser',
            'deleteReply',
            'upload',
            'uploadSuccess',
            'fav',
            'openMoreManagerDialog',
            'showOrHideReply'
        ];
        return _this;
    }
    TouristSafeJockey.prototype.getCookie = function (key) {
        var cookieObj = {};
        var cookieSplit;
        var cookieArr = document.cookie.split(';');
        cookieArr.forEach(function (item) {
            if (!item)
                { return false; }
            cookieSplit = item.split('=');
            cookieObj[cookieSplit[0].trim()] = cookieSplit[1].trim();
        });
        return !!cookieObj[key];
    };
    TouristSafeJockey.prototype.duIsLogin = function () {
        return this.getCookie('duToken');
    };
    // du-bridge.send('redirect',{key:28}) 处理redirect为28的模型
    TouristSafeJockey.prototype.isRedirect28 = function (event, params) {
        return event === 'redirect' && params && params.key === 28;
    };
    // 该jockey是否需要登录
    TouristSafeJockey.prototype.needLogin = function (event) {
        return this.JOCKEY_NEED_LOGIN.includes(event);
    };
    TouristSafeJockey.prototype.invokeLogin = function (event, params) {
        return (!this.duIsLogin() &&
            (this.isRedirect28(event, params) || this.needLogin(event)));
    };
    TouristSafeJockey.prototype.sendSync = function (event, params) {
        if (this.invokeLogin(event, params)) {
            _super.prototype.sendSync.call(this, CALL_NATIVE_LOGIN_MODAL, { code: this.TOURIST_CODE });
        }
        else {
            _super.prototype.sendSync.call(this, event, params);
        }
    };
    TouristSafeJockey.prototype.send = function (event, params, timeOutPeriod) {
        if (this.invokeLogin(event, params)) {
            return _super.prototype.send.call(this, CALL_NATIVE_LOGIN_MODAL, { code: this.TOURIST_CODE }, timeOutPeriod)
                .then(function () {
                throw Error('need login');
            });
        }
        return _super.prototype.send.call(this, event, params, timeOutPeriod);
    };
    return TouristSafeJockey;
}(SafeJockey));
var touristSafeJockey = new TouristSafeJockey();

var inQQMiniApp = /miniprogram/.test(navigator.userAgent) && /qq/i.test(navigator.userAgent);
// @ts-ignore
var inWXMiniApp = window.__wxjs_environment === 'miniprogram';
var inTTMiniApp = /ToutiaoMicroApp/.test(navigator.userAgent);
var MiniAppNavigator = /** @class */ (function () {
    function MiniAppNavigator() {
        this.inQQMiniApp = inQQMiniApp;
        this.inWXMiniApp = inWXMiniApp;
        this.inTTMiniApp = inTTMiniApp;
        this.sdkUrl = '';
        this.sdkLoad = false;
        this.init();
    }
    MiniAppNavigator.prototype.init = function () {
        var _this = this;
        if (this.inQQMiniApp) {
            this.sdkUrl =
                'https://qqq.gtimg.cn/miniprogram/webview_jssdk/qqjssdk-1.0.0.js';
        }
        else if (this.inWXMiniApp) {
            this.sdkUrl = ' https://res.wx.qq.com/open/js/jweixin-1.3.2.js';
        }
        else if (inTTMiniApp) {
            this.sdkUrl = 'https://s3.pstatp.com/toutiao/tmajssdk/jssdk.js';
        }
        var sdk = document.createElement('script');
        sdk.type = 'text/javascript';
        sdk.onload = function () {
            _this.sdkLoad = true;
        };
        sdk.src = this.sdkUrl;
        document.body.appendChild(sdk);
    };
    MiniAppNavigator.prototype.navigateTo = function (miniUrl) {
        if (!this.sdkLoad) {
            console.warn('小程序sdk还未加载完毕');
            return;
        }
        if (this.inQQMiniApp) {
            qq.miniProgram.navigateTo(miniUrl);
        }
        else if (this.inWXMiniApp) {
            wx.miniProgram.navigateTo(miniUrl);
        }
        else if (this.inTTMiniApp) {
            tt.miniProgram.navigateTo(miniUrl);
        }
    };
    return MiniAppNavigator;
}());
var miniAppNavigator = new MiniAppNavigator();
var inMiniApp = inQQMiniApp || inWXMiniApp || inTTMiniApp;

function navigateToN(routeName, params) {
    return touristSafeJockey.send(routeName, params);
}
function navigateToM(routeName) {
    miniAppNavigator.navigateTo({ url: routeName });
}
function navigatorToLogin(code) {
    return touristSafeJockey.send(CALL_NATIVE_LOGIN_MODAL, { code: code });
}
function navigateToW(routeName) {
    window.location.href = routeName;
}
function navigateTo(routeName, params) {
    if (inDuAppBrowser) {
        return navigateToN(routeName, params);
    }
    else if (inMiniApp) {
        navigateToM(routeName);
    }
    else {
        navigateToW(routeName);
    }
}
var navigator$1 = {
    navigateToN: navigateToN,
    navigateToM: navigateToM,
    navigateToW: navigateToW,
    navigateTo: navigateTo,
    navigatorToLogin: navigatorToLogin
};

var superman = {
    // 设置native网页标题
    setTitle: function (title) {
        touristSafeJockey.sendSync(SET_TITLE, { title: title });
    },
    // 设置是否显示分享按钮
    showShareBtn: function (show) {
        touristSafeJockey.sendSync(SHOW_SHARE_BTN, { data: show });
    },
    // 打开客服
    connectToStaff: function (params) {
        touristSafeJockey.sendSync(CONNECT_STAFF, params);
    },
    // native提供的大图预览
    previewImages: function (params) {
        touristSafeJockey.sendSync(PREVIEW_IMAGES, params);
    },
    // 设置native分享内容
    setShareContent: function (params) {
        touristSafeJockey.sendSync(SET_SHARE_CONTENT, params);
    },
    // 调用原生分享功能
    evokeShare: function (params) {
        return touristSafeJockey.send(EVOKE_SHARE, params, 1000 * 60 * 60);
    },
    //  获取native信息
    getPlatformInfo: function (params) {
        return touristSafeJockey.send(GET_PLATFORM_INFO, params || {});
    }
};

var informer = {
    trackEvent: function (_a) {
        var _b = _a.page, page = _b === void 0 ? '' : _b, _c = _a.access, access = _c === void 0 ? '' : _c, _d = _a.block, block = _d === void 0 ? '' : _d, _e = _a.event, event = _e === void 0 ? '' : _e, _f = _a.position, position = _f === void 0 ? '' : _f, _g = _a.duration, duration = _g === void 0 ? '' : _g, _h = _a.data, data = _h === void 0 ? '' : _h;
        touristSafeJockey.sendSync(EVENT_TRACKING, {
            page: page,
            access: access,
            block: block,
            event: event,
            position: position,
            duration: duration,
            data: data
        });
    }
};

var DuBridge = /** @class */ (function () {
    function DuBridge(navigator, superman, informer, duSafeJockey) {
        this.Navigator = navigator;
        this.Superman = superman;
        this.Informer = informer;
        this.duSafeJockey = duSafeJockey;
    }
    DuBridge.getInstance = function (navigator, superman, informer, duSafeJockey) {
        if (!DuBridge.instance) {
            DuBridge.instance = new DuBridge(navigator, superman, informer, duSafeJockey);
        }
        return DuBridge.instance;
    };
    DuBridge.inDuAppBrowser = inDuAppBrowser;
    return DuBridge;
}());

var duBridge = DuBridge.getInstance(navigator$1, superman, informer, touristSafeJockey);

export default duBridge;
